import '../embed/styles/base.css';
import { BrowserWidget } from '../embed/pages/BrowserWidget';
import { API_BASE } from '../lib/chatApi';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useStore } from '../context/StoreContext';

export default function Browser() {
  const [params] = useSearchParams();
  const initialQuery = params.get('q') || undefined;
  const navigate = useNavigate();
  const { storeId } = useStore();

  return (
    <div className="w-full h-screen">
      <BrowserWidget
        storeId={storeId}
        apiBase={API_BASE}
        initialQuery={initialQuery}
        onRetry={() => navigate('/browser/entry')}
        onClose={() => navigate('/')}
      />
    </div>
  );
}


